import React from "react";

function Services() {
    return (
        <section id="services">
            <div className="section-text">
                <div className="section-text__title-centered">
                    How can we help you with RenTara!
                </div>
                <div className="service-cards">
                    <div className="service-card">
                        <div className="service-card__icon">
                            <ion-icon name="reader-outline" />
                        </div>
                        <div className="service-card__text-container">
                            <div className="section-text__title-small">Easily Manage</div>
                            <div className="section-text__body">
                            Effortlessly conquer your rental management tasks with RenTara - the secret weapon for landlords who prefer 'easy' over 'oh, no!
                            </div>
                        </div>
                    </div>

                    <div className="service-card active">
                        <div className="service-card__icon">
                            <ion-icon name="wallet-outline" />
                        </div>
                        <div className="service-card__text-container">
                            <div className="section-text__title-small">
                                Get Payments Easily
                            </div>
                            <div className="section-text__body">
                            Say goodbye to rent collection headaches and hello to the sweet sound of cash flowing effortlessly into your pockets with RenTara!
                            </div>
                        </div>
                    </div>

                    <div className="service-card">
                        <div className="service-card__icon">
                            <ion-icon name="chatbubble-ellipses-outline" />
                        </div>
                        <div className="service-card__text-container">
                            <div className="section-text__title-small">Tenant Experience</div>
                            <div className="section-text__body">
                            Unlock the secret to happy tenants and seamless communication with RenTara, because a happy tenant is a rent-paying tenant!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Services;
